export default __webpack_public_path__ + "static/media/Custom-HUD-00.342c3a93.jpg";